import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

@Directive({
  selector: '[deleteDialog]',
  standalone: false,
})
export class DeleteDialogDirective {
  @Input() public deletionType: string;
  @Input() public deletionTypeText: string;
  @Input() public deletionTypeHeader: string;
  @Input() public deletionText: string;
  @Input() public isDisabled = false;
  @Output() public onDelete: EventEmitter<any> = new EventEmitter();

  constructor(private dialog: MatDialog) {}

  @HostListener('click')
  onClick() {
    if (this.isDisabled === true) {
      return;
    }
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: this.deletionTypeHeader,
        text: this.deletionText,
        type: this.deletionType,
        value: this.deletionTypeText,
      },
      panelClass: 'confirm-dialog-panel',
      disableClose: true,
      autoFocus: true,
    });
    dialogRef.afterClosed().subscribe((result) => (result ? this.onDelete.emit() : null));
  }
}
